import actions from './actions';

const {
  // GET ISSUE
  ISSUE_READ_BEGIN,
  ISSUE_READ_SUCCESS,
  ISSUE_READ_ERR,
  // ASSIGN ISSUE
  //   ISSUE_ASSIGN_BEGIN,
  ISSUE_ASSIGN_SUCCESS,
  //   ISSUE_ASSIGN_ERR,
} = actions;

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const issueReducers = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case ISSUE_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case ISSUE_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case ISSUE_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case ISSUE_ASSIGN_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    default:
      return state;
  }
};

export { issueReducers };
